require('./scss/styles.scss');
import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import swal from 'sweetalert'
import { mixins } from './mixins'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
//import favicon from '@/assets/logo/logo.png' MAS ADELANTE

let user = JSON.parse(localStorage.getItem('user'));

if(user) {
  let token = user.access_token;
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

axios.defaults.baseURL = 'https://backend.mundoaseosas.com.co/api/v1/';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

// Hook para ejecutar código después de cada navegación
router.afterEach((to, from) => {
  //console.log('Ruta actual:', to.path);
  //console.log('Ruta completa:', to.fullPath);
  if (to.path !== '/login') {
   // Interceptor de respuesta para manejar el error 401
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401 ) {      
          let item = JSON.parse(localStorage.getItem('user'));
          item = null;
          localStorage.setItem("user", JSON.stringify(item));
          alert("Usuario no autenticado. Redirigiendo al login...");
          window.location.href = '/';  // Redirige al login
        }
        return Promise.reject(error);
      }
    );
  }
});

Vue.mixin(mixins);

window.axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
